import React from "react";
import i18n from "../../../utilities/i18n";
import Box from '@mui/material/Box';
import PasswordChangeForm from "../Components/PassWordChangeForm";

const ForceResetPassword = () => {
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            flex={1}
            p={2}
            sx={{
                minHeight: '100vh',
                background: "linear-gradient(to right, #ebf8ff, #ffffff, #ebf8ff)",
            }}
        >
            <Box sx={{ width: '100%', maxWidth: 400 }}>
                <PasswordChangeForm
                    type="force-reset"
                    header={i18n.t('changePassword.header.title')}
                />
            </Box>
        </Box>
    );
};

export default ForceResetPassword;
